/**
 * E.164 phone number validation, shared across the API, mobile, and the
 * cross-app contracts.
 *
 * Pattern: "+", a non-zero country-code digit, then 6-14 more digits (7-15
 * total). The 15-digit ceiling is the E.164 maximum; the 7-digit floor matches
 * the shortest reachable international numbers and the strictness WhatsApp and
 * Twilio require for a deliverable number (WhatsApp is the primary phone
 * channel, so we validate to what it will actually accept).
 */
export const E164_REGEX = /^\+[1-9]\d{6,14}$/u;

/** True when `value` is a syntactically valid E.164 phone number. */
export function isValidE164(value: string): boolean {
  return E164_REGEX.test(value);
}

// Transport schemes Twilio and the mobile voice plugin prepend to
// otherwise-E.164 handles (`whatsapp:+386...`, `tel:+33...`, `sip:...`).
const TRANSPORT_PREFIX_RE = /^(?:whatsapp|tel|sip):/u;

/** Strip a leading `whatsapp:` / `tel:` / `sip:` transport scheme, if any. */
export function stripTransportPrefix(value: string): string {
  return value.replace(TRANSPORT_PREFIX_RE, "");
}
